export const selectPrivilege = (state) => state.privileges.data;